// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"206":"3f042eaa","787":"f150b143"}[chunkId] + ".chunk.js";
};